<template>
  <div class="site-page nav-content-inset">
    <div class="site-page__inner">
      <h1 class="site-page__title">站内信</h1>
      <el-table :data="items" v-loading="loading" border>
        <el-table-column prop="source" label="来源" width="100" />
        <el-table-column prop="message" label="内容" min-width="280" />
        <el-table-column label="时间" width="170">
          <template #default="s">{{ formatTime(s.row.createdAt) }}</template>
        </el-table-column>
        <el-table-column label="状态" width="80">
          <template #default="s">{{ s.row.isRead ? '已读' : '未读' }}</template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="total > pageSize"
        class="pager"
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        :current-page="page"
        @current-change="onPage"
      />
    </div>
  </div>
</template>

<script>
import { fetchUserMessages } from '@/utils/userHub'

export default {
  name: 'UserMessagesView',
  data() {
    return {
      loading: false,
      items: [],
      total: 0,
      page: 1,
      pageSize: 20
    }
  },
  created() {
    this.load()
  },
  methods: {
    formatTime(ts) {
      if (!ts) return '—'
      return new Date(Number(ts) * 1000).toLocaleString()
    },
    async load() {
      this.loading = true
      try {
        const data = await fetchUserMessages({ page: this.page, pageSize: this.pageSize })
        this.items = data.items || []
        this.total = data.total || 0
      } catch (e) {
        this.$message.error(e.message || '加载失败')
      } finally {
        this.loading = false
      }
    },
    onPage(p) {
      this.page = p
      this.load()
    }
  }
}
</script>

<style scoped>
.pager { margin-top: 16px; justify-content: center; }
</style>
